import { css, Interpolation, Theme } from '@emotion/react'

export const title: Interpolation<Theme> = (theme: Theme) => css`
  font-weight: 700;
  color: ${theme.typographyColors.typographyTwo};
`
